import { Box } from "@mui/material";
import CustomModal from "components/customModal";
import React from "react";
import { Calendar } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "./index.scss";

const CustomModalBirthday = ({ open, close, setBirthday }) => {
  return (
    <CustomModal
      open={open}
      handleClose={close}
      title="تاریخ تولد خود را وارد کنید"
      customstyle={{
        paddingBottom: "15px !important",
        height: "fit-content",
        width: "fit-content",
      }}
    >
      <Box sx={{ width: "100%", height: "100%" }}>
        <Calendar
          calendar={persian}
          locale={persian_fa}
          maxDate={new Date()}
          shadow={false}
          onChange={(data) => {
            setBirthday(`${data.year}/${data.month.number}/${data.day}`);
          }}
        />
      </Box>
    </CustomModal>
  );
};

export default CustomModalBirthday;
